import React, { PureComponent } from 'react';
import './CollapsibleTabs.scss';

class CollapsibleTabs extends PureComponent {

    constructor(props) {
        super(props);
    }

    toggleCollapsedState = ev => {
        const el = ev.target;
        let labelEl = el;
        if (el.classList.contains('fa')) {
            labelEl = el.parentElement;
        }
        const parentContainer = labelEl.parentElement;
        const iconEl = labelEl.children[0];
        if (parentContainer.classList.contains('expanded')) {
            parentContainer.classList.remove('expanded');
            iconEl.classList.remove('fa-minus');
            iconEl.classList.add('fa-plus');
        } else {
            parentContainer.classList.add('expanded');
            iconEl.classList.remove('fa-plus');
            iconEl.classList.add('fa-minus');
        }
    }

    render() {
        const { tabsData, className } = this.props;
        return (
            <section className={`collapsibleTabs ${className}`}>
                {
                    tabsData && tabsData.map((tab, idx) => {
                        return (
                            <div className="collapsibleTabs_tab container-fluid" key={`collapsibleTabs-${idx}`}>
                                <div className="collapsibleTabs_label" onClick={this.toggleCollapsedState}>
                                    {tab.label}
                                    <i className="fa fa-plus pull-right" aria-hidden="true"></i>
                                </div>
                                <div className="collapsibleTabs_content">
                                    <div dangerouslySetInnerHTML={{ __html: tab.html }}></div>
                                </div>
                            </div>
                        );
                    })
                }
            </section>
        );
    }
}

export default CollapsibleTabs;
